import React, { useContext } from 'react'

import styled, { ThemeContext } from 'styled-components'
import RedeemStakeCard from './RedeemStakeCard'
import { TYPE } from 'theme'

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 320px;
  overflow: auto;
  margin: auto;
  height: 100%;

  /* Scrollbar styling for WebKit-based browsers (Chrome, Edge, Safari) */
  ::-webkit-scrollbar {
    width: 6px; /* Width of the scrollbar */
    border-radius: 12px;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #4afb39; /* Thumb color */
    border-radius: 12px; /* Rounded corners */
  }

  ::-webkit-scrollbar-track {
    background-color: #171717; /* Track background color */
  }

  /* Scrollbar styling for Firefox */
  scrollbar-width: thin; /* Thin scrollbar */
  scrollbar-color: #4afb39 #171717; /* Thumb color followed by track color */
`

interface VestingI {
  data: any
  refresh: () => void
}
const Vesting: React.FC<VestingI> = ({ data, refresh }) => {
  const theme = useContext(ThemeContext)
  return (
    <ContainerStyled>
      {data.length > 0 ? (
        <>
          {data.map((vesting: any, index: number) => {
            return <RedeemStakeCard key={index} id={index} vesting={vesting} refresh={refresh} />
          })}
        </>
      ) : (
        <div style={{ display: 'flex', height: '100%' }}>
          <TYPE.mediumHeader textAlign="center" color={theme.text3} style={{ margin: 'auto' }}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
              className="icon icon-tabler icons-tabler-outline icon-tabler-alarm-average"
              style={{ marginBottom: '.5rem' }}
            >
              <path stroke="none" d="M0 0h24v24H0z" fill="none" />
              <path d="M5 13a7 7 0 1 0 14 0a7 7 0 0 0 -14 0" />
              <path d="M7 4l-2.75 2" />
              <path d="M17 4l2.75 2" />
              <path d="M8 13h1l2 3l2 -6l2 3h1" />
            </svg>
            <div>{'You have no open positions on vested $xSWAP tokens.'}</div>
          </TYPE.mediumHeader>
        </div>
      )}
    </ContainerStyled>
  )
}
export default Vesting
